<ng-container *ngIf="!isLive; else live">
  <div *ngIf="!isAd && (seeking || seekingWithMouse)" class="seekbar-thumbnails">
    <div *ngFor="let thumb of thumbnails; let i = index" class="seekbar-thumbnails-item" [ngStyle]="{
      'background-image': 'url(' + thumb + ')',
      'visibility': !!thumb ? 'visible' : 'hidden'
    }"
    [ngClass]="{
      'active': i == 2
    }"><span class="seekbar-thumbnails-item-time">{{ value | secondsToTimePlayer }}</span></div>
  </div>
  <div
    #button
    tabindex="0"
    class="seekbar-button focusable-element"
    [ngClass]="{ 'ad': isAd }"
    [ngStyle]="{ transform: 'translateX(' + (max | playerSeekbar: value:bar) + 'px)' }"
    (keydown)="onKeyDown($event)"
    (keyup)="onKeyUp($event)"
    (mousedown)="onMouseDown()"
    (focusout)="onFocusOut()" 
  ></div>
  <ng-container *ngIf="showCuepoints">
      <div class="cuepoint-container">
        <div *ngFor="let point of cuepoints" class="cuepoint"  [ngClass]="{ 'ad': isAd }"
          [ngStyle]="{ transform: 'translateX(' + (max | playerSeekbar: point.realPlayerTime : bar ) + 'px)' }"
          ></div>
      </div>
  </ng-container>
  <div #bar class="seekbar-bar" [ngStyle]="{ transform: 'scaleX(' + (max | playerSeekbar: value) + ')' }" [ngClass]="{ 'ad': isAd }"></div>
</ng-container>
<ng-template #live>
  <div tabindex="0" class="seekbar-button live focusable-element" (keyup)="onKeyUpLive($event)" (keydown)="onKeyDownLive($event)"></div>
  <div #bar class="seekbar-bar live"></div>
</ng-template>
